import { useState } from "react";
import Next from "./icons/Next";

export function Roadmap() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleView = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={"lg:w-[454px] w-[245px] rounded-[20px] overflow-hidden duration-500 transition-all" + (isOpen ? " max-h-[216px]" : " lg:max-h-[100px] max-h-[60px]")}>
            <div className="flex bg-purple-rosa justify-evenly lg:h-[100px] h-[60px] cursor-pointer" onClick={toggleView}>
                <span className="flex items-center justify-center m-0 lg:text-60 text-40">Roadmap</span>
                <span className={"duration-500 flex items-center justify-center transition-transform " + (isOpen ? "rotate-90" : "")}>
                    <Next />
                </span>
            </div>
            <div className="bg-purple-750 max-h-[116px] flex items-center justify-center overflow-hidden">
                <span className="m-0 lg:text-80 text-40">???</span>
            </div>
        </div>
    );
}